/** Клон map полей для хранения в pageData */
export function cloneSerializableFieldMap(
  fields: Record<string, unknown>,
): Record<string, unknown> {
  let cloned: Record<string, unknown>
  try {
    cloned = JSON.parse(JSON.stringify(fields)) as Record<string, unknown>
  } catch {
    const walked = cloneWalk(fields, 0)
    cloned =
      walked && typeof walked === 'object' && !Array.isArray(walked)
        ? (walked as Record<string, unknown>)
        : {}
  }
  return sanitizeFieldMap(cloned)
}

function isNonCloneableLeaf(val: unknown): boolean {
  if (val == null) return false
  const t = typeof val
  if (t === 'function' || t === 'symbol' || t === 'bigint') return true
  if (t === 'object') {
    if (typeof Window !== 'undefined' && val instanceof Window) return true
    if (typeof Node !== 'undefined' && val instanceof Node) return true
  }
  return false
}

function cloneWalk(val: unknown, depth: number): unknown {
  if (depth > 24 || isNonCloneableLeaf(val)) return undefined
  if (val == null || typeof val !== 'object') return val

  if (Array.isArray(val)) {
    return val
      .map((item) => cloneWalk(item, depth + 1))
      .filter((item) => item !== undefined)
  }

  const obj = val as Record<string, unknown>
  if (
    Object.prototype.hasOwnProperty.call(obj, 'type') &&
    Object.prototype.hasOwnProperty.call(obj, 'value') &&
    isNonCloneableLeaf(obj.value)
  ) {
    return undefined
  }

  const out: Record<string, unknown> = {}
  for (const [key, child] of Object.entries(obj)) {
    if (isNonCloneableLeaf(child)) continue
    const cloned = cloneWalk(child, depth + 1)
    if (cloned !== undefined) out[key] = cloned
  }
  return out
}

function sanitizeFieldEntry(field: unknown): unknown {
  if (field == null || typeof field !== 'object') return field
  if (Array.isArray(field)) {
    return field.map((item) => sanitizeFieldEntry(item)).filter((item) => item !== undefined)
  }
  const f = field as Record<string, unknown>
  if (Object.prototype.hasOwnProperty.call(f, 'type')) {
    if (
      !Object.prototype.hasOwnProperty.call(f, 'value') ||
      f.value === undefined ||
      isNonCloneableLeaf(f.value)
    ) {
      return undefined
    }
    return { ...f, value: sanitizeFieldEntry(f.value) }
  }
  const out: Record<string, unknown> = {}
  for (const [key, child] of Object.entries(f)) {
    const sanitized = sanitizeFieldEntry(child)
    if (sanitized !== undefined) out[key] = sanitized
  }
  return Object.keys(out).length > 0 ? out : undefined
}

function sanitizeFieldMap(fields: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {}
  for (const [key, field] of Object.entries(fields)) {
    const sanitized = sanitizeFieldEntry(field)
    if (sanitized !== undefined) out[key] = sanitized
  }
  return out
}
